<template>
  <div class="tw-relative">
    <div ref="trigger">
      <slot :open="open"></slot>
    </div>
    <div v-show="is_open" ref="menu" class="tw-rounded tw-overflow-hidden tw-bg-light tw-shadow tw-w-96">
      <div class="tw-divide-y tw-divide-light-3">
        <a href="/dashboard" class="tw-block tw-py-5 tw-px-4 cursor:tw-text-blue cursor:tw-bg-light-4">
          <i class="bx bx-home tw-relative tw-top-2px tw-text-4xl tw-mr-1"></i>
          <span class="tw-font-semibold">Dashboard</span>
        </a>
        <a :href="`/user/${user.username}`" class="tw-block tw-py-5 tw-px-4 cursor:tw-text-blue cursor:tw-bg-light-4">
          <i class="bx bx-user tw-relative tw-top-2px tw-text-4xl tw-mr-1"></i>
          <span class="tw-font-semibold">View My Profile</span>
        </a>
        <a href="/dashboard/profile" class="tw-block tw-py-5 tw-px-4 cursor:tw-text-blue cursor:tw-bg-light-4">
          <i class="bx bx-edit-alt tw-relative tw-top-2px tw-text-4xl tw-mr-1"></i>
          <span class="tw-font-semibold">Edit My Profile</span>
        </a>
        <a href="/dashboard/task" class="tw-block tw-py-5 tw-px-4 cursor:tw-text-blue cursor:tw-bg-light-4">
          <i class="bx bx-task tw-relative tw-top-2px tw-text-4xl tw-mr-1"></i>
          <span class="tw-font-semibold">My Tasks</span>
        </a>

        <a href="/dashboard/profile/transactions" class="tw-block tw-py-5 tw-px-4 cursor:tw-text-blue cursor:tw-bg-light-4">
          <i class="bx bx-list-ul tw-relative tw-top-2px tw-text-4xl tw-mr-1"></i>
          <span class="tw-font-semibold">My Transactions</span>
        </a>

        <a href="/dashboard/message" class="tw-block tw-py-5 tw-px-4 cursor:tw-text-blue cursor:tw-bg-light-4">
          <i class="bx bx-message tw-relative tw-top-2px tw-text-4xl tw-mr-1"></i>
          <span class="tw-font-semibold">My Messages</span>
        </a>
        <a href="/logout" class="tw-block tw-py-5 tw-px-4 cursor:tw-text-blue cursor:tw-bg-light-4">
          <i class="bx bx-log-out tw-relative tw-top-2px tw-text-4xl tw-mr-1"></i>
          <span class="tw-font-semibold">Log Out</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  import {createPopper} from '@popperjs/core';

  export default {
    data: v => ({
      is_open: false,
    }),
    props: {
      user: {},
    },
    created() {
      this.open = _.throttle(() => {
        this.is_open = true
      }, 100)
      this.close = _.throttle(() => this.is_open = false, 100)

      let documentClickCallback = ev => {
        if (ev.target !== this.$el && !this.$el.contains(ev.target)) {
          this.close()
        }
      }
      this.$on('hook:mounted', () => document.addEventListener('click', documentClickCallback))
      this.$on('hook:beforeDestroy', () => document.removeEventListener('click', documentClickCallback))
    },
    watch: {
      is_open(value) {
        value && createPopper(this.$refs.trigger, this.$refs.menu, {
          placement: "bottom",
        })
      }
    }
  }
</script>
